import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

//import ModalReducer from './modal';
import AuthReducer from './auth';
import DashboardReducer from './dashboards';
import CategoriesReducer from './categories';
import PlayersReducer from './players';
import AddressDBsReducer from './addressdbs';
import AdvertisesReducer from './advertises';
import CompaniesReducer from './companies';
import CampaignsReducer from './campaigns';
import DevicesReducer from './devices';
import StatisticsReducer from './statistics';
import SettlementsReducer from './settlements';
import ManageReducer from './manage';
import AddressesReducer from './addresses';

const rootReducer = (history) => {
  //console.log('history ->' + history);
  // if (action.type === 'LOGOUT') {
  //   localStorage.clear();
  //   state = undefined;
  // }

  return combineReducers({
    router: connectRouter(history),
    auth: AuthReducer,
    dashboards: DashboardReducer,
    categories: CategoriesReducer,
    players: PlayersReducer,
    addressdbs: AddressDBsReducer,
    advertises: AdvertisesReducer,
    companies: CompaniesReducer,
    campaigns: CampaignsReducer,
    devices: DevicesReducer,
    statistics: StatisticsReducer,
    settlements: SettlementsReducer,
    manage: ManageReducer,
    addresses: AddressesReducer,
  });

  //return appReducer(state, action);
};

export default rootReducer;
